import type { AccountServiceFeatures } from '@jwp/ott-common/src/services/integrations/AccountService';

export type PaymentsPage = AccountServiceFeatures['paymentsPage'];

export const resolvePaymentsPage = (paymentsPage: PaymentsPage, supportsCustomerPortal = true) => {
  const resolvedPaymentsPage = paymentsPage === 'hosted' && !supportsCustomerPortal ? 'in-app' : paymentsPage;

  return {
    // this enables the payments menu item and routes to the Payments screen
    paymentsEnabled: resolvedPaymentsPage === 'in-app',
    // this enables the manage subscription menu item which opens an external page to manage the subscription
    manageSubscriptionEnabled: resolvedPaymentsPage === 'hosted',
  };
};
